module.exports = __webpack_public_path__ + "static/img/how-to-check-the-limit-before-buying-a-car-thumbnail.0966c6c.jpg";